import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Mimari",
    desc: "Her proje sağlam bir temelle başlar. Ölçeklenebilir, sürdürülebilir ve işletmenin büyümesine hazır sistemler kurarım.",
  },
  {
    n: "02",
    title: "Temiz Kod",
    desc: "Okunabilir, test edilebilir, bakımı kolay kod. Yarın başka bir geliştirici devraldığında teşekkür edecek.",
  },
  {
    n: "03",
    title: "Performans",
    desc: "Hız bir özellik değil, standarttır. Hızlı yüklenen sayfalar, akıcı animasyonlar, mutlu kullanıcılar.",
  },
  {
    n: "04",
    title: "Destek",
    desc: "Teslim bitiş değildir. Proje yayına alındıktan sonra da yanında olurum — güncelleme, iyileştirme, danışmanlık.",
  },
];

const Manifesto = () => (
  <section id="prensipler" className="px-6 lg:px-16 py-28">
    <div className="max-w-7xl mx-auto">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-16"
      >
        <span className="font-code text-xs text-[#10B981] tracking-[0.3em]">MANİFESTO</span>
        <h2 className="font-display font-bold text-4xl sm:text-5xl mt-4 tracking-tight">
          Nasıl çalışırım<span className="text-[#10B981]">?</span>
        </h2>
      </motion.div>

      <div>
        {chapters.map((c, i) => (
          <motion.div
            key={c.n}
            data-testid={`manifesto-chapter-${c.n}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.08 }}
            className="group grid md:grid-cols-12 gap-4 md:gap-8 items-baseline border-t border-white/[0.07] py-10 hover:bg-white/[0.02] transition-colors duration-500 px-2 md:px-4 -mx-2 md:-mx-4"
          >
            <span className="font-code text-sm text-[#F59E0B] md:col-span-1">{c.n}</span>
            <h3 className="font-display font-bold text-2xl md:text-3xl md:col-span-4 tracking-tight group-hover:text-[#10B981] transition-colors duration-500">
              {c.title}
            </h3>
            <p className="text-[#9CA3AF] leading-relaxed md:col-span-7">{c.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
